import { render, staticRenderFns } from "./DialogAddGoodType.vue?vue&type=template&id=26535889&scoped=true&"
import script from "./DialogAddGoodType.vue?vue&type=script&lang=js&"
export * from "./DialogAddGoodType.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddGoodType.vue?vue&type=style&index=0&id=26535889&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26535889",
  null
  
)

export default component.exports